import React, { useRef } from "react";
import { Background } from "../Style/Background";
import { ModalWrapper } from "../Style/ModalWrapper";
import { ModalContent } from "../Style/ModalContent";
import { ModalImg } from "../Style/ModalImg";
import IMG from "../../Assets/Images/3-PhotoRoom low res.webp";
import RingLoader from "react-spinners/RingLoader";

export const Modal = ({ showModal, setShowModal }) => {
	const modalRef = useRef(null); //add null as initial value of useRef

	const generateRandomColor = () => {
		return "#" + Math.floor(Math.random() * 16777215).toString(16);
	};

	return (
		<>
			{showModal && (
				<Background ref={modalRef}>
					<ModalWrapper showModal={showModal}>
						<ModalImg src={IMG} alt="Munyaradzi's Photo" />{" "}
						{/* Complete the alt attribute */}
						<ModalContent>
							<h3>SoftwareGeniuses</h3>
							<p>
								Thank you for visiting my software engineering portfolio site!
								My team and I specializes in delivering innovative and cost-effective
								solutions that help companies achieve their software goals.
								<br />
								<br />
								While my website is still under construction, feel free to
								browse my portfolio, services, and contact me with any
								inquiries.
							</p>
							<RingLoader
								color={generateRandomColor()}
								size={150}
								loading={true}
							/>
							<p>Last website update: July 1st, 2023</p>
							<p>Last CV update: March 20, 2023</p>
						</ModalContent>
					</ModalWrapper>
				</Background>
			)}
		</>
	);
};
